import { Box } from "@mui/material";
import { InputSelect } from "../../../components/input/input";
import { useState } from "react";

interface IReportGraphicFilter {
  onYearChange(item: string): void;
  onMonthChange(item: string): void;
  onTypeChange(item: number): void;
}

export default function ReportGraphicFilter({
  onMonthChange,
  onYearChange,
  onTypeChange,
}: IReportGraphicFilter) {
  const [selectedType, setSelectedType] = useState(1);
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedYear, setSelectedYear] = useState();
  const monthOptions = [
    { text: "Januari", value: "01-01" },
    { text: "Februari", value: "02-01" },
    { text: "Maret", value: "03-01" },
    { text: "April", value: "04-01" },
    { text: "Mei", value: "05-01" },
    { text: "Juni", value: "06-01" },
    { text: "Juli", value: "07-01" },
    { text: "Agustus", value: "08-01" },
    { text: "September", value: "09-01" },
    { text: "Oktober", value: "10-01" },
    { text: "November", value: "11-01" },
    { text: "Desember", value: "12-01" },
  ];
  const generateYearOptions = (startYear: any) => {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let y = startYear; y <= currentYear; y++) {
      years.push({ text: String(y), value: y });
    }

    return years;
  };
  const yearOptions = generateYearOptions(2020);

  return (
    <Box>
      <Box mb={2}>
        <InputSelect
          id={"select-mode"}
          label="Tipe"
          options={[
            { text: "Bulan", value: 1 },
            { text: "Tahun", value: 2 },
          ]}
          onChange={(e) => {
            setSelectedType(e);
            onTypeChange(e);
          }}
          value={selectedType}
        />
      </Box>
      <Box display={"flex"} gap={1}>
        <InputSelect
          id={"select-year-1"}
          label="Tahun"
          options={yearOptions}
          onChange={(e) => {
            setSelectedYear(e);
            onYearChange(e);
          }}
          value={selectedYear}
        />
        {selectedType === 1 && (
          <InputSelect
            id={"select-month-1"}
            label="Bulan"
            options={monthOptions}
            onChange={(e) => {
              setSelectedMonth(e);
              onMonthChange(e);
            }}
            value={selectedMonth}
          />
        )}
      </Box>
    </Box>
  );
}
